// import React, { useState, useEffect } from "react";
// import {
//   User,
//   Mail,
//   Phone,
//   MapPin,
//   Calendar,
//   Globe,
//   UserCheck,
// } from "lucide-react";

// const Profile = () => {
//   const [adminData, setAdminData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchAdminData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const localDataString = localStorage.getItem(
//           "CovenantDevelopersAdminData"
//         );

//         if (!localDataString) {
//           throw new Error("No admin data found in local storage");
//         }

//         const localData = JSON.parse(localDataString);

//         if (!localData || !localData.id) {
//           throw new Error("No admin ID found in local storage data");
//         }

//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/admins/get-admin-by-id/${localData.id}`
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();

//         if (data.admin) {
//           setAdminData(data.admin);
//         } else {
//           setAdminData(localData);
//         }
//       } catch (err) {
//         console.error("Error fetching admin data:", err);

//         try {
//           const localDataString = localStorage.getItem(
//             "CovenantDevelopersAdminData"
//           );
//           if (localDataString) {
//             const localData = JSON.parse(localDataString);
//             setAdminData(localData);
//             setError(null);
//           } else {
//             throw err;
//           }
//         } catch (fallbackErr) {
//           setError(err.message);
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAdminData();
//   }, []);

//   const formatDate = (dateString) => {
//     if (!dateString) return "Not specified";
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });
//   };

//   const SkeletonLoader = () => (
//     <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100 p-6">
//       <div className="w-full mx-auto">
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
//           {/* Header Skeleton */}
//           <div className="relative bg-gradient-to-r from-orange-600 to-orange-700 p-8">
//             <div className="flex flex-col md:flex-row items-center gap-6">
//               <div className="w-32 h-32 bg-white/20 rounded-full animate-pulse"></div>
//               <div className="text-center md:text-left flex-1">
//                 <div className="h-8 bg-white/20 rounded-lg w-64 mb-3 animate-pulse"></div>
//                 <div className="h-6 bg-white/20 rounded-lg w-48 mb-2 animate-pulse"></div>
//                 <div className="h-5 bg-white/20 rounded-lg w-32 animate-pulse"></div>
//               </div>
//             </div>
//           </div>

//           {/* Content Skeleton */}
//           <div className="p-8">
//             <div className="grid md:grid-cols-2 gap-8">
//               {[...Array(6)].map((_, index) => (
//                 <div
//                   key={index}
//                   className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl"
//                 >
//                   <div className="w-12 h-12 bg-gray-200 rounded-full animate-pulse"></div>
//                   <div className="flex-1">
//                     <div className="h-4 bg-gray-200 rounded w-24 mb-2 animate-pulse"></div>
//                     <div className="h-6 bg-gray-200 rounded w-40 animate-pulse"></div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   if (loading) {
//     return <SkeletonLoader />;
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-100 p-6 flex items-center justify-center">
//         <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
//           <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
//             <svg
//               className="w-8 h-8 text-red-500"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//               />
//             </svg>
//           </div>
//           <h3 className="text-xl font-semibold text-gray-900 mb-2">
//             Error Loading Profile
//           </h3>
//           <p className="text-gray-600 mb-4">{error}</p>
//           <button
//             onClick={() => window.location.reload()}
//             className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg transition-colors"
//           >
//             Try Again
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!adminData) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6 flex items-center justify-center">
//         <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
//           <h3 className="text-xl font-semibold text-gray-900 mb-2">
//             No Profile Data
//           </h3>
//           <p className="text-gray-600">Unable to load profile information.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100 p-6">
//       <div className="w-full mx-auto">
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform hover:scale-[1.01] transition-transform duration-300">
//           {/* Header Section */}
//           <div className="relative bg-gradient-to-r from-orange-600 to-orange-700 p-8">
//             <div className="absolute inset-0 bg-black/10"></div>
//             <div className="relative flex flex-col md:flex-row items-center gap-6">
//               <div className="relative group">
//                 <img
//                   src={adminData.profilePic}
//                   alt={adminData.name}
//                   className="w-24 h-24 rounded-full border-4 border-white shadow-lg object-cover group-hover:scale-105 transition-transform duration-300"
//                 />
//                 <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-transparent to-white/20 group-hover:to-white/30 transition-all duration-300"></div>
//               </div>
//               <div className="text-center md:text-left text-white flex-1">
//                 <h1 className="text-2xl md:text-4xl font-bold mb-2 drop-shadow-sm">
//                   {adminData.name}
//                 </h1>
//                 <p className="text-lg text-indigo-100 mb-2 flex items-center justify-center md:justify-start gap-2">
//                   <Mail className="w-5 h-5" />
//                   {adminData.email}
//                 </p>
//                 <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
//                   <UserCheck className="w-4 h-4" />
//                   <span className="font-semibold capitalize">
//                     {adminData.userType}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Details Section */}
//           <div className="p-8">
//             <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
//               <User className="w-6 h-6 text-indigo-600" />
//               Profile Details
//             </h2>

//             <div className="grid md:grid-cols-2 gap-6">
//               {/* Phone Number */}
//               <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl hover:shadow-md transition-shadow duration-300">
//                 <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
//                   <Phone className="w-6 h-6 text-blue-600" />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-500 mb-1">
//                     Phone Number
//                   </p>
//                   <p className="text-lg font-semibold text-gray-900">
//                     {adminData.phoneNumber}
//                   </p>
//                 </div>
//               </div>

//               {/* Gender */}
//               <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl hover:shadow-md transition-shadow duration-300">
//                 <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
//                   <User className="w-6 h-6 text-purple-600" />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-500 mb-1">
//                     Gender
//                   </p>
//                   <p className="text-lg font-semibold text-gray-900 capitalize">
//                     {adminData.gender}
//                   </p>
//                 </div>
//               </div>

//               {/* Date of Birth */}
//               <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl hover:shadow-md transition-shadow duration-300">
//                 <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
//                   <Calendar className="w-6 h-6 text-green-600" />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-500 mb-1">
//                     Date of Birth
//                   </p>
//                   <p className="text-lg font-semibold text-gray-900">
//                     {formatDate(adminData.dateOfBirth)}
//                   </p>
//                 </div>
//               </div>

//               {/* Nationality */}
//               <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-orange-50 to-yellow-50 rounded-xl hover:shadow-md transition-shadow duration-300">
//                 <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
//                   <Globe className="w-6 h-6 text-orange-600" />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-500 mb-1">
//                     Nationality
//                   </p>
//                   <p className="text-lg font-semibold text-gray-900">
//                     {adminData.nationality}
//                   </p>
//                 </div>
//               </div>

//               {/* Address */}
//               <div className="md:col-span-2 flex items-start gap-4 p-4 bg-gradient-to-r from-gray-50 to-slate-50 rounded-xl hover:shadow-md transition-shadow duration-300">
//                 <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
//                   <MapPin className="w-6 h-6 text-gray-600" />
//                 </div>
//                 <div>
//                   <p className="text-sm font-medium text-gray-500 mb-1">
//                     Address
//                   </p>
//                   <p className="text-lg font-semibold text-gray-900">
//                     {adminData.address}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Profile;

import React, { useState, useEffect } from "react";
import {
  User,
  Mail,
  Phone,
  MapPin,
  Calendar,
  Globe,
  UserCheck,
  Edit,
  X,
  Upload,
} from "lucide-react";

const Profile = () => {
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState(null);

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        setLoading(true);
        setError(null);

        const localDataString = localStorage.getItem(
          "CovenantDevelopersAdminData"
        );

        if (!localDataString) {
          throw new Error("No admin data found in local storage");
        }

        const localData = JSON.parse(localDataString);

        if (!localData || !localData.id) {
          throw new Error("No admin ID found in local storage data");
        }

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/admins/get-admin-by-id/${localData.id}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.admin) {
          setAdminData(data.admin);
        } else {
          setAdminData(localData);
        }
      } catch (err) {
        console.error("Error fetching admin data:", err);

        try {
          const localDataString = localStorage.getItem(
            "CovenantDevelopersAdminData"
          );
          if (localDataString) {
            const localData = JSON.parse(localDataString);
            setAdminData(localData);
            setError(null);
          } else {
            throw err;
          }
        } catch (fallbackErr) {
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleEditClick = () => {
    setEditFormData({ ...adminData });
    setIsEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
    setEditFormData(null);
    setSaveMessage(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({
      ...editFormData,
      [name]: value,
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingImage(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);

      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}/image/upload`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to upload image");
      }

      const data = await response.json();
      setEditFormData({
        ...editFormData,
        profilePic: data.secure_url,
      });
    } catch (err) {
      console.error("Error uploading image:", err);
      setSaveMessage({
        type: "error",
        text: "Failed to upload image. Please try again.",
      });
    } finally {
      setUploadingImage(false);
    }
  };

  const handleSaveProfile = async () => {
    try {
      setIsSaving(true);
      setSaveMessage(null);

      const localDataString = localStorage.getItem(
        "CovenantDevelopersAdminData"
      );
      const localData = JSON.parse(localDataString);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admins/admin-edit-profile/${localData.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: editFormData.name,
            email: editFormData.email,
            phoneNumber: editFormData.phoneNumber,
            gender: editFormData.gender,
            dateOfBirth: editFormData.dateOfBirth,
            address: editFormData.address,
            nationality: editFormData.nationality,
            profilePic: editFormData.profilePic,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setAdminData(editFormData);
      setSaveMessage({
        type: "success",
        text: "Profile updated successfully!",
      });

      setTimeout(() => {
        handleCloseModal();
      }, 1500);
    } catch (err) {
      console.error("Error saving profile:", err);
      setSaveMessage({
        type: "error",
        text: err.message || "Failed to update profile. Please try again.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const SkeletonLoader = () => (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100 p-6">
      <div className="w-full mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="relative bg-gradient-to-r from-orange-600 to-orange-700 p-8">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="w-32 h-32 bg-white/20 rounded-full animate-pulse"></div>
              <div className="text-center md:text-left flex-1">
                <div className="h-8 bg-white/20 rounded-lg w-64 mb-3 animate-pulse"></div>
                <div className="h-6 bg-white/20 rounded-lg w-48 mb-2 animate-pulse"></div>
                <div className="h-5 bg-white/20 rounded-lg w-32 animate-pulse"></div>
              </div>
            </div>
          </div>

          <div className="p-8">
            <div className="grid md:grid-cols-2 gap-8">
              {[...Array(6)].map((_, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl"
                >
                  <div className="w-12 h-12 bg-gray-200 rounded-full animate-pulse"></div>
                  <div className="flex-1">
                    <div className="h-4 bg-gray-200 rounded w-24 mb-2 animate-pulse"></div>
                    <div className="h-6 bg-gray-200 rounded w-40 animate-pulse"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (loading) {
    return <SkeletonLoader />;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 to-pink-100 p-6 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Error Loading Profile
          </h3>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (!adminData) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            No Profile Data
          </h3>
          <p className="text-gray-600">Unable to load profile information.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100 p-6">
      <div className="w-full mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform hover:scale-[1.01] transition-transform duration-300">
          {/* Header Section */}
          <div className="relative bg-gradient-to-r from-orange-600 to-orange-700 p-8">
            <div className="absolute inset-0 bg-black/10"></div>
            <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex flex-col md:flex-row items-center gap-6 flex-1">
                <div className="relative group">
                  <img
                    src={adminData.profilePic}
                    alt={adminData.name}
                    className="w-24 h-24 rounded-full border-4 border-white shadow-lg object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-transparent to-white/20 group-hover:to-white/30 transition-all duration-300"></div>
                </div>
                <div className="text-center md:text-left text-white flex-1">
                  <h1 className="text-2xl md:text-4xl font-bold mb-2 drop-shadow-sm">
                    {adminData.name}
                  </h1>
                  <p className="text-lg text-indigo-100 mb-2 flex items-center justify-center md:justify-start gap-2">
                    <Mail className="w-5 h-5" />
                    {adminData.email}
                  </p>
                  <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
                    <UserCheck className="w-4 h-4" />
                    <span className="font-semibold capitalize">
                      {adminData.userType}
                    </span>
                  </div>
                </div>
              </div>
              <button
                onClick={handleEditClick}
                className="flex items-center gap-2 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white px-6 py-3 rounded-lg transition-all duration-300 border border-white/30"
              >
                <Edit className="w-5 h-5" />
                Edit Profile
              </button>
            </div>
          </div>

          {/* Details Section */}
          <div className="p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
              <User className="w-6 h-6 text-indigo-600" />
              Profile Details
            </h2>

            <div className="grid md:grid-cols-2 gap-6">
              {/* Phone Number */}
              <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <Phone className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 mb-1">
                    Phone Number
                  </p>
                  <p className="text-lg font-semibold text-gray-900">
                    {adminData.phoneNumber}
                  </p>
                </div>
              </div>

              {/* Gender */}
              <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                  <User className="w-6 h-6 text-purple-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 mb-1">
                    Gender
                  </p>
                  <p className="text-lg font-semibold text-gray-900 capitalize">
                    {adminData.gender}
                  </p>
                </div>
              </div>

              {/* Date of Birth */}
              <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <Calendar className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 mb-1">
                    Date of Birth
                  </p>
                  <p className="text-lg font-semibold text-gray-900">
                    {formatDate(adminData.dateOfBirth)}
                  </p>
                </div>
              </div>

              {/* Nationality */}
              <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-orange-50 to-yellow-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                  <Globe className="w-6 h-6 text-orange-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 mb-1">
                    Nationality
                  </p>
                  <p className="text-lg font-semibold text-gray-900">
                    {adminData.nationality}
                  </p>
                </div>
              </div>

              {/* Address */}
              <div className="md:col-span-2 flex items-start gap-4 p-4 bg-gradient-to-r from-gray-50 to-slate-50 rounded-xl hover:shadow-md transition-shadow duration-300">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <MapPin className="w-6 h-6 text-gray-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 mb-1">
                    Address
                  </p>
                  <p className="text-lg font-semibold text-gray-900">
                    {adminData.address}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {isEditModalOpen && editFormData && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="sticky top-0 bg-gradient-to-r from-orange-600 to-orange-700 p-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-white flex items-center gap-2">
                <Edit className="w-6 h-6" />
                Edit Profile
              </h2>
              <button
                onClick={handleCloseModal}
                className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-8">
              {saveMessage && (
                <div
                  className={`mb-6 p-4 rounded-lg flex items-center gap-3 ${
                    saveMessage.type === "success"
                      ? "bg-green-50 text-green-800 border border-green-200"
                      : "bg-red-50 text-red-800 border border-red-200"
                  }`}
                >
                  {saveMessage.type === "success" ? (
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                  <span>{saveMessage.text}</span>
                </div>
              )}

              {/* Profile Picture Upload */}
              <div className="mb-8">
                <label className="block text-sm font-semibold text-gray-900 mb-4">
                  Profile Picture
                </label>
                <div className="flex items-center gap-6">
                  <img
                    src={editFormData.profilePic}
                    alt="Profile"
                    className="w-20 h-20 rounded-full object-cover border-2 border-indigo-200"
                  />
                  <label className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors cursor-pointer disabled:opacity-50">
                    <Upload className="w-4 h-4" />
                    {uploadingImage ? "Uploading..." : "Upload Image"}
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      disabled={uploadingImage}
                      className="hidden"
                    />
                  </label>
                </div>
              </div>

              {/* Form Fields */}
              <div className="grid md:grid-cols-2 gap-6">
                {/* Name */}
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={editFormData.name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={editFormData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </div>

                {/* Phone Number */}
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={editFormData.phoneNumber}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </div>

                {/* Gender */}
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Gender
                  </label>
                  <select
                    name="gender"
                    value={editFormData.gender}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                {/* Date of Birth */}
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    name="dateOfBirth"
                    value={editFormData.dateOfBirth}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </div>

                {/* Nationality */}
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Nationality
                  </label>
                  <input
                    type="text"
                    name="nationality"
                    value={editFormData.nationality}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </div>

                {/* Address */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Address
                  </label>
                  <textarea
                    name="address"
                    value={editFormData.address}
                    onChange={handleInputChange}
                    rows="3"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  ></textarea>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="mt-8 flex gap-4 justify-end">
                <button
                  onClick={handleCloseModal}
                  className="px-6 py-2 bg-gray-200 text-gray-900 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveProfile}
                  disabled={isSaving}
                  className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSaving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
